namespace $ { $mol_style_attach( "giper/balls/catalog/catalog.view.css",
 "[giper_balls_catalog_board] {\n\t-webkit-user-select: none;\n}\n\nhtml, body {\n  overscroll-behavior-x: none;\n  touch-action: none;\n}\n"
) }